<template>
    <div class="row">
        <div class="col-md-12 mb-50">
            <label class="form-label">Referans Model</label>
            <v-select-list multiple :options="c_referenceModels" label="VehicleReferenceModelManuelName" v-model="referenceModel" placeholder="Referans Model"></v-select-list>
        </div>
        <div class="col-md-12 mb-1">
            <b-form-checkbox v-model="rememberReferenceModel" inline>Referans Modeli Hatırla</b-form-checkbox>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-12 mb-1">
                    <label class="form-label">Başlangıç İli</label>
                    <v-select-list v-model="startProvince" :options="provinces" label="Name" v-on:input="getDistricts(true)" placeholder="Başlangıç İli"></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Başlangıç İlçesi</label>
                    <v-select-list :disabled="!startProvince" v-model="startDistrict" :options="startDistricts" label="Name" placeholder="Başlangıç İlçesi" v-on:input="getNeighbourhood(true)"></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Başlangıç Mahallesi</label>
                    <v-select-list :disabled="!startDistrict || startNeighbourhoods.length == 0" v-model="startNeighbourhood" :options="startNeighbourhoods" label="Name" placeholder="Başlangıç Mahallesi"></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <div class="map-wrapper" :class="{'disabled':!startProvince || !startDistrict || !startNeighbourhood}">
                        <google-maps-find-location :address="startAddress" v-on:location="startLatLng = $event"></google-maps-find-location>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-12 mb-1">
                    <label class="form-label">Varış İli</label>
                    <v-select-list v-model="endProvince" :options="provinces" label="Name" v-on:input="getDistricts(false)" placeholder="Varış İli"></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Varış İlçesi</label>
                    <v-select-list :disabled="!endProvince" v-model="endDistrict" :options="endDistricts" label="Name" placeholder="Varış İlçesi" v-on:input="getNeighbourhood(false)"></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Varış Mahallesi</label>
                    <v-select-list :disabled="!endDistrict || endNeighbourhoods.length == 0" v-model="endNeighbourhood" :options="endNeighbourhoods" label="Name" placeholder="Varış Mahallesi"></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <div class="map-wrapper" :class="{'disabled':!endProvince || !endDistrict || !endNeighbourhood}">
                        <google-maps-find-location :address="endAddress" v-on:location="endLatLng = $event"></google-maps-find-location>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Sefer Sayısı</label>
            <input type="number" v-model="countOfTrips" class="form-control" placeholder="Sefer Sayısı"/>
        </div>
        <!-- <div class="col-md-6 mb-1">
            <label class="form-label">Çalışılan Gün Sayısı</label>
            <input type="number" v-model="countOfDaysWorked" class="form-control" placeholder="Çalışılan Gün Sayısı"/>
        </div> -->
        <div class="col-md-6 mb-1">
            <label class="form-label">Müşteri Mesafe</label>
            <input type="number" class="form-control" v-model="customerKm" />
        </div>
        <div class="col-md-12 mb-1">
            <b-form-checkbox v-model="isAvoidTolls" inline>Paralı Yolları Dahil Et</b-form-checkbox>
            <b-form-checkbox v-model="isAvoidHighways" inline>Anayolları Dahil Et</b-form-checkbox>
        </div>
        <div class="col-md-12">
            <v-executer :disabled="c_disabledCalculate" full-width variant="success" :loading="calculating" text="Hesapla ve Ekle" :action="calculateDistance"></v-executer>
        </div>
    </div>
</template>

<script>
import CalculatePriceApi from '@/api/calculate-price'
import SystemDataApi from '@/api/system-data'
import {BFormCheckbox} from 'bootstrap-vue'
import GoogleMapsFindLocation from '@/components/GoogleMapsFindLocation'
import GoogleMaps from '@/utilities/google-maps'
import randomatic from 'randomatic'
export default {
    props:{
        value:Object,
        oneDayKm:Number,
    },
    components:{
        BFormCheckbox,
        GoogleMapsFindLocation
    },
    data(){
        return{
            referenceModels: [],
            referenceModel: [],
            provinces:[],
            startProvince:null,
            endProvince:null,
            startDistricts:[],
            endDistricts:[],
            startDistrict:null,
            endDistrict:null,
            startNeighbourhoods:[],
            startNeighbourhood:null,
            startLatLng:null,
            endNeighbourhoods:[],
            endNeighbourhood:null,
            endLatLng:null,
            rememberReferenceModel:false,
            isAvoidTolls:false,
            isAvoidHighways:false,
            calculating:false,
            customerKm:0,
            countOfTrips:1,
            countOfDaysWorked:1,
        }
    },
    watch:{
        startProvince(){
            this.startDistrict = null
            this.startNeighbourhood = null
        },
        endProvince(){
            this.endDistrict = null
            this.endNeighbourhood = null
        },
        startDistrict(){
            this.startNeighbourhood = null
        },
        endDistrict(){
            this.endNeighbourhood = null
        }
    },
    mounted(){
        this.getReferenceModels()
        this.getProvince()
    },
    methods:{
        clearForm(){
            this.startProvince = null
            this.endProvince = null
            this.startDistrict = null
            this.endDistrict = null
            this.startNeighbourhood = null
            this.endNeighbourhood = null
            this.startLatLng = null
            this.endLatLng = null
            this.customerKm = 0
            this.countOfTrips = 1
            this.countOfDaysWorked = 1
            if(!this.rememberReferenceModel){
                this.referenceModel = []
            }
        },
        getReferenceModels(){
            CalculatePriceApi.ReferenceModel.List()
            .then(res=>{
                this.referenceModels = res.data.Data
            })
        },
        getProvince(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241')
            .then((res) => {
                this.provinces = res.data.Data
            })
        },
        getDistricts(bool){
            if(this.startProvince?.Id || this.endProvince?.Id){
                let id = bool ? this.startProvince?.Id : this.endProvince?.Id
                SystemDataApi.District(id)
                .then((res) => {
                    if(bool) this.startDistricts = res.data.Data
                    else this.endDistricts = res.data.Data
                })
            }
        },
        getNeighbourhood(bool){
            if(this.startProvince?.Id || this.endProvince?.Id || this.startDistrict?.Id || this.endDistrict?.Id){
                let id = bool ? this.startDistrict?.Id : this.endDistrict?.Id
                SystemDataApi.Neighborhood(id)
                .then((res) => {
                    if(bool) this.startNeighbourhoods = res.data.Data
                    else this.endNeighbourhoods = res.data.Data
                })
            }
        },
        calculateDistance(){
            if(this.startProvince && this.endProvince && this.startDistrict && this.endDistrict && this.startNeighbourhood && this.endNeighbourhood){
                this.calculating = true
                const requestData ={
                    StartProvinceId:this.startProvince.Id,
                    StartProvinceName:this.startProvince.Name,
                    StartDistrictId:this.startDistrict.Id,
                    StartDistrictName:this.startDistrict.Name,
                    StartNeighborhoodId:this.startNeighbourhood.Id,
                    StartNeighborhoodName:this.startNeighbourhood.Name,
                    StartLocationLat:this.startLatLng?.lat ? String(this.startLatLng.lat) : null,
                    StartLocationLong:this.startLatLng?.lng ? String(this.startLatLng.lng) : null,
                    EndProvinceId:this.endProvince.Id || null,
                    EndProvinceName:this.endProvince.Name || null, 
                    EndDistrictId:this.endDistrict.Id || null,
                    EndDistrictName:this.endDistrict.Name || null,
                    EndNeighborhoodId:this.endNeighbourhood.Id || null,
                    EndNeighborhoodName:this.endNeighbourhood.Name || null,
                    EndLocationLat:this.endLatLng?.lat ? String(this.endLatLng.lat) : null,
                    EndLocationLong:this.endLatLng?.lng ? String(this.endLatLng.lng) : null,
                    Tolls:this.isAvoidTolls,
                    Highways: this.isAvoidHighways,
                    CustomerKm:this.customerKm,
                    CountOfTrips:this.countOfTrips,
                }
                
                CalculatePriceApi.DraftPrice.CalculateDistance(requestData).then(res=>{
                    this.calculating = false
                    if(res.data.Success){
                        this.referenceModel.forEach(rm => {
                            const route = this.uncalculatedData(res.data.Data,'Exact',rm,this.oneDayKm)
                            this.value.UncalculatedRoutes.push(route)
                        })
                        this.clearForm()
                    }else this.$result(res)
                }).catch(err=>{
                    this.calculating = false
                    this.$result(null,err)
                })

            }
        },
        uncalculatedData(data,type,rm,oneDayKm){
            return {
                id:randomatic("A0",10),
                selected:false,
                startProvince: data.StartProvinceId ? { Id:data.StartProvinceId, Name:data.StartProvinceName } : null,
                startDistrict: data.StartDistrictId ? { Id:data.StartDistrictId, Name:data.StartDistrictName } : null,
                startNeighbourhood: data.StartNeighborhoodId ? { Id:data.StartNeighborhoodId, Name:data.StartNeighborhoodName } : null,
                startLatLng: data.StartLocationLat && data.StartLocationLong ? {Lat:data.StartLocationLat,Lng:data.StartLocationLong} : null,
                endProvince: data.EndProvinceId ? { Id:data.EndProvinceId, Name:data.EndProvinceName } : null,
                endDistrict: data.EndDistrictId ? { Id:data.EndDistrictId, Name:data.EndDistrictName } : null,
                endNeighbourhood: data.EndNeighborhoodId ? { Id:data.EndNeighborhoodId, Name:data.EndNeighborhoodName } : null,
                endLatLng: data.EndLocationLat && data.EndLocationLong ? {Lat:data.EndLocationLat,Lng:data.EndLocationLong} : null,
                customerKm:data.CustomerKm,
                isAvoidTolls:data.Tolls,
                isAvoidHighways:data.Highways,
                referenceModel:rm,
                countOfTrips:data.CountOfTrips,
                countOfDaysWorked:Math.ceil(data.Distance/oneDayKm),
                type:type,
                calculatedDistance: data.Distance
            }
        },
    },
    computed:{
        startAddress(){
            return [
                this.startProvince?.Name || '',
                this.startDistrict?.Name || '',
                this.startNeighbourhood?.Name || ''
            ].join(',')
        },
        endAddress(){
            return [
                this.endProvince?.Name || '',
                this.endDistrict?.Name || '',
                this.endNeighbourhood?.Name || ''
            ].join(',')
        },
        c_disabledCalculate(){
            if(this.referenceModel.length > 0 
                && this.startProvince 
                && this.endProvince 
                && this.startDistrict 
                && this.endDistrict 
                && this.endNeighbourhood 
                && this.startNeighbourhood
                && this.startLatLng
                && this.endLatLng) return false
            else return true
        },
        c_referenceModels(){
            if(this.referenceModel.length > 0){
                const first = this.referenceModel[0]
                return this.referenceModels.filter(rm => rm.GroupNumber == first.GroupNumber)
            }else return this.referenceModels
        }
    }
}
</script>

<style>
.map-wrapper{
    height: 400px;
}
.map-wrapper.disabled{
    opacity: 0.5;
    pointer-events: none;
}
</style>